export default "__VITE_ASSET__D7gF$bVZ__"